import { CustomSearchParams } from "@/components/common/deep-link/deep-link-encoding";
import { removeSearchParam } from "@/components/common/deep-link/deep-link-utils";
import { ReactComponent as PublishSuccessSvg } from "@/components/ui/icons/publish-success.svg";
import { WorkflowDialog } from "@faro-lotv/data-management";
import { FaroButton } from "@faro-lotv/flat-ui";
import { ReactNode, useState } from "react";
import { useSearchParams } from "react-router-dom";

/**
 * @returns Modal dialog with a success message that gets shown when the ?showPublishSuccess=true
 *          URL search parameter is provided for successfully publishing the project.
 */
export function PublishSuccessDialog(): ReactNode {
  const [searchParams] = useSearchParams();
  const show = searchParams.has(CustomSearchParams.showPublishSuccess);
  const [isOpen, setIsOpen] = useState(show);

  if (show) {
    // Remove the no longer needed URL search parameter.
    removeSearchParam(CustomSearchParams.showPublishSuccess);
  }

  return (
    <WorkflowDialog
      variant="notice"
      open={isOpen}
      title="Ready to explore"
      description="Your project has been published! You can start exploring it now or return to manage your data."
      image={PublishSuccessSvg}
      actions={
        <FaroButton
          // Set the focus on the button so that the dialog can also be closed with the Return key,
          // but remove the ugly default border around the button.
          autoFocus
          sx={{
            "&.MuiButton-root:focus-visible": {
              boxShadow: "none",
              outline: "none",
            },
          }}
          onClick={() => {
            setIsOpen(false);
          }}
        >
          Let's start
        </FaroButton>
      }
    />
  );
}
